import { MediaType } from "@jconradi/tutu-porn-api-client/src/media";
import { MediaListItem } from "@jconradi/tutu-porn-api-client/src/users"
import { TutuDefaultSeo } from "../Seo/TutuDefaultSeo"

export const MediaSeo = ({ media }: { media: MediaListItem}) => {
    const title = media.title;
    const description = `Watch ${media.title} from @${media.user.username} on tutu.porn, the best XXX porn site. TutuPorn is home to the widest selection of free sex videos, photos, and gallerys. If you're craving fast, free XXX movies you'll find them here`
    
    const openGraph: any = {
        images: [{
            url: `${media.urls.poster}?width=640&height=360`
        }]
    };

    if (media.mediaType === MediaType.Video) {
        openGraph.type = "video.movie";
        openGraph.video = {
            url: media.urls.hd, // TODO: use embed player
            duration: media.info.duration || 0
        }
    }
    else if (media.mediaType === MediaType.Photo) {

    }
    else if (media.mediaType === MediaType.Gallery) {

    }

    return (
        <TutuDefaultSeo title={title} description={title ? description : undefined} openGraph={openGraph} />
    )
}